module.exports = __webpack_public_path__ + "img/kr.25dcfe4c.png";